import React from 'react'
import { hasChildren } from '../../utils/utils';
import MultiLevel from './MultiLevel';
import SingleLevel from './SingleLevel';
import PropTypes from 'prop-types';

export default function MenuSidebar({ item }) {
    return hasChildren(item) ? <MultiLevel item={item} /> : <SingleLevel item={item}/>;
}

MenuSidebar.propTypes = {
    item: PropTypes.any,
}
